import { ADDRESS_CONSTRAINTS } from '../address/constraints.js';
export const CAL_EVENT_VENUE_LIMITS = {
    name: ADDRESS_CONSTRAINTS.name.maxLength,
    address: ADDRESS_CONSTRAINTS.address.maxLength,
    city: ADDRESS_CONSTRAINTS.city.maxLength,
    zip: ADDRESS_CONSTRAINTS.zip.maxLength,
};
//# sourceMappingURL=cal-event-venue-limits.js.map